// Link to Ridesizer app
export default () => "http://ridesizer.guardianbikes.com";


// WEBPACK FOOTER //
// ./src/functions/getExternalLink.js